
import { faCaretDown, faCaretUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Collapse } from "@material-ui/core";
import { FC, ReactNode, useEffect, useState } from "react";
import "./styles.scss";


interface GrupoPagamentoProperties {
    title: ReactNode;
    startOpen?: boolean;
    open?: boolean | null;
    onOpenChage?: (isOpen: boolean) => void;
}

const GrupoPagamento: FC<GrupoPagamentoProperties> = ({
    title,
    startOpen = true,
    open = null,
    onOpenChage,
    children
}) => {
    const [openState, setOpenState] = useState<boolean>(false);

    useEffect(() => {
        setOpenState(startOpen)
    }, []);

    useEffect(() => {
        if (open !== null && open !== undefined) {
            setOpenState(open)
        }
    }, [open]);

    return <div className="GrupoPagamento">
        <div className="header" onClick={() => {
            const isOpen: boolean = !openState;
            setOpenState(isOpen)
            if (onOpenChage) {
                onOpenChage(isOpen)
            }
        }}>
            <div className="title">
                {title}
            </div>
            <div className="icon" >
                {openState ? <><FontAwesomeIcon icon={faCaretUp} /></> : <><FontAwesomeIcon icon={faCaretDown} /></>}
            </div>
        </div>
        <Collapse in={openState}>
            <div className="content">{children}</div>
        </Collapse>
    </div>
}

export { GrupoPagamento }